import React from 'react';
import { userLoader } from '../../actions/data_loaders';
import withDataLoaded from '../with_data_loaded';
import PageSpinner from '../shared/page_spinner';
import AuthorizedSignerList from './authorized_signer_list';

function AuthorizedSignerPage() {
  return (
    <div className="admin-authorized-signers-page">
      <AuthorizedSignerList />
    </div>
  );
}

export default withDataLoaded({
  WithData: AuthorizedSignerPage,
  WithoutData: PageSpinner,
  data: [userLoader],
});
